import { parse } from '@sellsy/numberformat';

export function persistOcr(data, params) {
    let ocr = {
        supplier_id: data.supplier,
        date: data.documentDate.split(' ')[0],
        due_date: data.dueDate.split(' ')[0],
        ident: data.externalDocumentName,
        currency_id: params.currencies.find(currency => currency.name === data.currency)?.id,
        step: data.step,
        note: data.note,
        rows: data.products.map(product => {
            return {
                description: product.description,
                tax_rate_id: product.tva,
                tax_amount: NumberFormat.formatToFloat(product.priceTva, params.numformat),
                accounting_code_id: product.accountingCode,
                amount_excl: parse(product.priceWithoutTax.toString(), { ...params.numformat, ...detectFormat(product.priceWithoutTax) }),
                amount_incl: parse(product.priceWithTax.toString(), { ...params.numformat, ...detectFormat(product.priceWithTax) }),
            };
        }),
        tags: data.tags,
        payments: data.payments.filter(payment => {
            //filter for dont sent empty payment row (payment reference is not required so dont check it)
            return !_.isEmpty(payment.date) && !_.isNil(payment.amount) && ! _.isNil(payment.payment_mean);
        }).map(payment => { 
            return { 
                ...payment, 
                date: !_.isNil(payment.date) ? payment.date.split(' ')[0] : null,
                amount: !_.isNil(payment.amount) ? parse(payment.amount, { ...params.numformat, ...detectFormat(payment.amount) }) : null
            } 
        }),
        total_excl: data.totalWithoutTax,
        total_incl: data.totalWithTax
    }; 

    return ocr;
}

export function detectFormat(value) {
    let finalFormat = {
        thousands: ' '
    }
    const noSpaceValue = value.toString().replaceAll(' ', '');
    let separators = {
        coma: noSpaceValue.indexOf(','),
        dot: noSpaceValue.indexOf('.')
    };

    if (separators.coma !== -1 && separators.dot === -1) {
        finalFormat.decimals = ',';
    } else if (separators.coma === -1 && separators.dot !== -1) {
        finalFormat.decimals = '.';
    }

    if (separators.coma !== -1 && separators.dot !== -1) {
        if (separators.coma > separators.dot) {
            finalFormat.decimals = ',';
            finalFormat.thousands = '.';
        } else if (separators.coma < separators.dot) {
            finalFormat.decimals = '.';
            finalFormat.thousands = ',';
        }
    }

    return finalFormat;
}